import { Policy } from '@/components/Policy';

export default {
  path: '/policy',
  component: Policy,
  meta: {
    text: '利用規約',
    level: 0,
  },
};
